import CurrencyService, {
    convertPrice,
    getAllConversionRates,
    getSupportedCurrencies,
    hydrate,
    loadConversionRatesForCurrency,
} from './currencyService';

export {
    convertPrice,
    getAllConversionRates,
    getSupportedCurrencies,
    hydrate,
    loadConversionRatesForCurrency,
};

export default CurrencyService;
